import '@naturehouse/design-system/components/atoms/multi-stepper/MultiStepper';
import '@naturehouse/design-system/components/atoms/multi-stepper/Step';
import '@naturehouse/design-system/components/molecules/dialog/Dialog';
import '@naturehouse/design-system/components/molecules/dialog/MultiStepDialog';
import '@naturehouse/design-system/components/molecules/navigation-dropdown/NavigationDropdown';
import '@naturehouse/design-system/components/organisms/navigation/Navigation';
import Curtain from '../../ui/Curtain';
import '../app/webComponents/StickyCTA';
import Module from '../module';
import CheckUnreadChatMessagesComponent from '../shared/components/CheckUnreadChatMessagesComponent';
import ChatChannelListComponent from '../shared/components/chatChannelListComponent';
import AccountVerification from './verification/AccountVerification';
import StampDialogHandler from './StampDialogHandler';

export default class AccountModule extends Module {
    constructor() {
        super();

        document.addEventListener('DOMContentLoaded', (): void => {
            AccountVerification.getInstance();
        });

        StampDialogHandler.getInstance();

        this.components.push(ChatChannelListComponent);
        this.components.push(CheckUnreadChatMessagesComponent);
        this.components.push(Curtain);
    }
}

(function accountModuleInit(): void {
    const accountModule = new AccountModule();
    accountModule.init();
})();
